/**
 * Official EXPAS logo (bowtie mark + wordmark), traced from expas.tech.
 * Mark = ignition orange (brand); wordmark = currentColor (white on dark chrome,
 * adapts in light mode). Size via a height class, e.g. <Logo className="h-4" />.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 168 15" fill="none" role="img" aria-label="EXPAS" className={className}>
      {/* bowtie mark — official EXPAS orange */}
      <path className="fill-ignition" d="M44.422 15H68.0376V0H44.422L34.0188 7.5L44.422 15Z" />
      <path className="fill-ignition" d="M23.6148 0H0V15H23.6148L34.0188 7.5L23.6148 0Z" />
      {/* EXPAS wordmark */}
      <path
        fill="currentColor"
        d="M89.4413 0V2.39024H78.403V6.25326H88.7921V8.64428H78.403V12.609H89.4413V15H75.5735V0H89.4413Z"
      />
      <path
        fill="currentColor"
        d="M96.3722 0L101.634 6.06633L106.896 0H110.162L103.53 7.5L110.162 15H106.896L101.634 8.93367L96.3722 15H93.1064L99.7385 7.5L93.1064 0H96.3722Z"
      />
      <path
        fill="currentColor"
        d="M125.875 0C127.899 0 129.539 1.63234 129.539 3.64637V6.18443C129.539 8.19846 127.899 9.8308 125.875 9.8308H116.645V15H113.816V0H125.875ZM116.645 7.32871H125.002C125.945 7.32636 126.709 6.56846 126.709 5.62989V4.19934C126.709 3.26155 125.945 2.50052 125.002 2.50052H116.645V7.32871Z"
      />
      <path
        fill="currentColor"
        d="M140.766 0L148.883 15H145.812L144.031 11.5867H134.634L132.853 15H129.783L137.899 0H140.766ZM135.755 9.50073H142.911L139.333 2.63349L135.755 9.50073Z"
      />
      <path
        fill="currentColor"
        d="M163.642 0C165.666 0 167.307 1.63234 167.307 3.64637V4.8235H164.478V4.20013C164.448 3.2639 163.714 2.5013 162.771 2.5013H156.213C155.299 2.5013 154.575 3.15205 154.575 4.06169V4.60137C154.575 6.90948 167.609 5.36787 167.609 9.93717V11.3536C167.609 13.3677 165.968 15 163.944 15H155.41C153.386 15 151.746 13.3677 151.746 11.3536V10.1765H154.575V10.7991C154.575 11.7377 155.339 12.4979 156.282 12.4979H163.141C164.054 12.4979 164.778 11.8472 164.778 10.9383V10.3979C164.778 7.90593 151.745 9.58598 151.745 5.06283V3.64637C151.747 1.63234 153.387 0 155.41 0H163.642Z"
      />
    </svg>
  )
}
